
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { IAuthor, IAuthors, IDynamicElement } from '../_shared/models';
import { AuthorComponent } from '../author/author.component';
import { ContainerComponent } from '../container/container.component';

@Component({
    selector: 'sirius-authors',
    templateUrl: './authors.component.html',
    styleUrl: './authors.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AuthorComponent, ContainerComponent]
})
export class AuthorsComponent implements IDynamicElement, OnInit {
    @Input() authors: IAuthor[] = [];

    config?: IAuthors;

    ngOnInit(): void {
        if (this.config) {
            this.authors = this.config.authors;
        }
    }
}
